import { log } from '@dtk/logging';
import { useEffect, useState } from 'react';

export enum StreamState {
  INIT,
  ERROR,
  PENDING,
}

export const useWebsocket = (source: URL, onMessage: MessageCallback) => {
  const url = source.toString();
  const messageKeys = Object.keys(onMessage);
  const [state, setState] = useState<EventStreamState>({ state: StreamState.INIT });
  useEffect(() => {
    const websocket = new WebSocket(url);
    websocket.onmessage = function (event) {
      log(JSON.stringify(event));
      const message = JSON.parse(event.data);
      if (onMessage[message.type]) {
        onMessage[message.type](message.data);
      }
    };

    websocket.onopen = () => {
      setState({ state: StreamState.PENDING });
    };

    websocket.onerror = (error) => {
      log.warn({ error: JSON.stringify(error) }, 'Error in EventSource');
      setState({
        error: 'Error',
        state: StreamState.ERROR,
      });
    };
    return () => {
      log.info('Closing event source');
      websocket.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, messageKeys.join(',')]);

  return state;
};

export interface EventStreamState {
  state: StreamState;
  error?: string;
}
export type Callback<T> = { (message: T): void };
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type MessageCallback = Record<MessageName, Callback<any>>;
export type MessageName = string;
